import PropTypes from 'prop-types';
import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import SessionService from 'service/SessionService';
import './App.less';
import Home from './view/home/Home';
import Login from './view/login/Login';
import { getRequest } from 'service/HttpCommunicationService';

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoggedIn: false, auth: false };

    // 获取Token
    getRequest('/getCrsfToken');
  }

  render() {
    return (
      <Router>
        <div className="main">
          <Switch>
            <Route path="/login">
              <Login/>
            </Route>
            <PrivateRoute path="/">
              <Home/>
            </PrivateRoute>
          </Switch>
        </div>
      </Router>
    );
  }
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({ children, ...rest }) {
  const auth = SessionService.userName != null;
  return (
    <Route
      {...rest}
      render={() => auth ? (children) : (
        <Redirect to={{ pathname: '/login' }}/>
      )
      }
    />
  );
}

PrivateRoute.propTypes = {
  children: PropTypes.element.isRequired
};
